/* Copyright(c) 2021 APSS Media Pvt. Ltd.
*  All Rights Reserved
*/
/*@author Nilesh Zinzurao - 5668
*@fileName :CATLeadReport.js
@Creation Date:28-05-2025
*Desc: UI for CAT View- By Advertiser - Advertiser Lead Assessment Tracking Report
*/
import React from "react";
// import { Tabs, Tab } from 'react-bootstrap';
import Navigation from "../layouts/navPage";
// import * as $ from "jquery";
import Footer from "../layouts/footer";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logoutUser } from '../login/authentication';
import { withRouter } from 'react-router-dom';
import { FaArrowAltCircleLeft } from "react-icons/fa";
import './agencyMyReports.css';
// import { css } from "emotion";
import Picky from "react-picky";
import "react-picky/dist/picky.css";
// import styled from "styled-components";
import { Checkbox, Tooltip, Icon } from 'antd';
import styled from "styled-components";
// import { truncate } from "fs";
import { fetch_custom as fetch } from "../../configration/fetch_default_headers";      //3721-Rutuja Kale-VAPT-Agency side--Reports menu--URL Links & API-FE
import moment from 'moment';
import { saveAs } from "file-saver";
import { type } from "os";
// import { LeadReviewLoader } from "../loaders/LeadReviewLoader";

const xlsx = require("xlsx");


const Swal = require('sweetalert2');
// const CheckboxGroup = Checkbox.Group;
var chunk1 = []; //4639-Nilesh- stored data in batches


//sunita-task-3579- added code to change the width
let z = 8000; //not resolve giving issue
let a = 60;
if (a === 60) {
  z = 120 * a
}

//Chaitanya - 4470 - added array  for lead status .
const leadStatusOptions =
  [
    { id: "Delivered", name: "Delivered" },
    { id: "Review-Pending", name: "Review-Pending" },
    { id: "Accepted", name: "Accepted" },
    { id: "Rejected", name: "Rejected" }
  ];

const HtmlTooltip = styled(Tooltip)`
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: '12px',
    border: '1px solid #dadde9',
    `;

class CATLeadReport extends React.Component {
  constructor() {
    super();
    this.state = {
      tableState: { size: "small" },//sunita-task-3413-used for table design
      agencyAdvertiserCampaignInfo: [],//sunita-task-3413-declared for table data
      agencyMyReportsDataNew1: [],//sunita-task-3413-declare to set table data in this new array while filtering the data
      agencyMyReportsData: [],//sunita-task-3413-array declared for table data
      advertiserList: [],//sunita-task-3413-array declared for advertiser name
      advertiserList1: [],//sunita-task-3413-array declared to filter advertiser name
      agencyID: "",// sunita-task-3413-declare to get the id from userLogin
      advertiserID: "Select Advertiser",//sunita-task-3413-used to display bydefault non-selected .
      campaignStatus: [],//sunita-task-3413-used to display bydefault non-selected .
      timeLine: "Select Timeline",//sunita-task-3413-used to display bydefault non-selected .
      label: "",//sunita-task-3413-used to filter deadline as per label .
      reportKey: "",//sunita-task-3413-used key to put conditions when user came by clicking on report name .
      advertiserName: "",//sunita-task-3413-to target advertiser name .
      type: "Advertiser Lead Tracking",//sunita-task-3413-given by default type
      reportName: "",//sunita-task-3413-used for report name .          
      loader: "",//sunita-task-3413-used for loader.
      campaignLoader: "",//sunita-3413-used for campaign loader.
      generateBtnFlag: false,//sunita-task-3413-used to enable - disable generate button.
      advID: '',//sunita-task-3413-used to access advid on this page came from myreport page.
      userType: "Advertiser",//sunita-task-3413-by default usertype
      pageSize: 100,//sunita-task-3413-added for page size.
      handleOnkey: 2,//sunita-task-3413-added for going back to my report page
      campID: "Select Campaign",//sunita-task-3413-declare campID for campaign dropdown .
      getCampaignListByADV: [],//sunita-task-3413-declare array  for getting the campaign list.
      advLeadDetails: [],//sunita-task-3413-declare array to iterate table data
      token: "",//sunita-task-3413-used token for authentication
      deliveryDetails: [],//sunita-task-3413-declare array to store the delivery format details
      leadStatus: [], //sunita-task-3413-array for leadstatus values
      campaignName: "",//sunita-task-3413-declare variable for campaign.
      campaignStatusArray: [],//sunita-task-3413-declare array for cmapaign status array .
      leadIndeterminate: true,//sunita-task-3413-used flag to setState checkbox value.
      leadCheckAll: false,//sunita-task-3413-used flag to check checkbox.
      campaignLeadStatusArray: [],//sunita-task-3413-declare array for  lead status array 
      checkedColumnKeys: [],//sunita-task-3413-declare array for checkbox value
      drpdisabled_report: "",//sunita-task-3413-declare for disable checkbox. 
      customQuestionCount: 0,//sunita-task-3413-declare variable for  customQuestionCount.
      multiTouch: "No",//sunita-task-3413-variable for multitouch.
      deadline: "", //sunita-task-3413-declare variable for timeline
      startDate: "",
      endDate: "",
      totalCount: 0,
      loader_progress: "", //4639-Nilesh Add loader
      splitedArray: [], //4639-Nielseh add array for batches data
      UserName: [],
      selectedUser: '',
      pacing: "Default",
      selectedUserKeys: [],    //Nilesh-5722- to store selected checkboxes (format: "orgID|userID")
      orgIDArray: [],          // only orgIDs
      userIDArray: [],         // only userIDs
      showDropdown: false,
      selectedUsers: [],
      UserName: [], // populate this from API or props
      searchText: "", //Nilesh-5722- Used for user serach
      clientSearchText: "", //Nilesh-5722- Used for client serach
      showClientDropdown: false,
    }//end of state

    //binded all below mentioned handle changes as per requirement
    this.onAdvertiserNameHandleChange = this.onAdvertiserNameHandleChange.bind(this);
    //this.onCampaignStatusHandleChange = this.onCampaignStatusHandleChange.bind(this);
    //this.ondeadlineHandleChange = this.ondeadlineHandleChange.bind(this);
    this.backButtonHandleChange = this.backButtonHandleChange.bind(this);
    this.searchHandleChange = this.searchHandleChange.bind(this);   //4470-Search button
    this.handledownloadLead = this.handledownloadLead.bind(this);   //4470-download button
    //this.onCampaignHandleChange = this.onCampaignHandleChange.bind(this);
    //this.onCampaignDetailsHandleChange = this.onCampaignDetailsHandleChange.bind(this);
    this.onCampaignLeadDetailsHandleChange = this.onCampaignLeadDetailsHandleChange.bind(this);
    //this.handleFileDownload = this.handleFileDownload.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.loadingRef = React.createRef();//4470-Loader
    this.closeLoadingRef = React.createRef();

  }// end of constrcutor

  //Nilesh-5722- This function used for select date range
  handleChange = (e) => {
    const { name, value } = e.target;

    const formatDate = (date, isStart = true) => {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      const time = isStart ? "00:00:00" : "23:59:59";
      return `${yyyy}-${mm}-${dd} ${time}`;
    };

    const today = new Date();
    let startDate = "";
    let endDate = "";

    if (name === "pacing") {
      switch (value) {
        case "Today":
          startDate = formatDate(today, true);
          endDate = formatDate(today, false);
          break;

        case "Yesterday":
          const yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          startDate = formatDate(yesterday, true);
          endDate = formatDate(yesterday, false);
          break;

        case "Weekly":
          const weekStart = new Date(today);
          weekStart.setDate(today.getDate() - today.getDay());
          startDate = formatDate(weekStart, true);
          endDate = formatDate(today, false);
          break;

        case "Last Week":
          const lastWeekEnd = new Date(today);
          lastWeekEnd.setDate(today.getDate() - today.getDay() - 1);
          const lastWeekStart = new Date(lastWeekEnd);
          lastWeekStart.setDate(lastWeekEnd.getDate() - 6);
          startDate = formatDate(lastWeekStart, true);
          endDate = formatDate(lastWeekEnd, false);
          break;

        case "Monthly":
          const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
          startDate = formatDate(monthStart, true);
          endDate = formatDate(today, false);
          break;

        case "Last Month":
          const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
          startDate = formatDate(lastMonthStart, true);
          endDate = formatDate(lastMonthEnd, false);
          break;

        case "Quarterly":
          const currentQuarter = Math.floor(today.getMonth() / 3);
          const qStart = new Date(today.getFullYear(), currentQuarter * 3, 1);
          startDate = formatDate(qStart, true);
          endDate = formatDate(today, false);
          break;

        case "Last Quarter":
          const lastQ = Math.floor(today.getMonth() / 3) - 1;
          const lastQuarterStart = new Date(today.getFullYear(), lastQ * 3, 1);
          const lastQuarterEnd = new Date(today.getFullYear(), lastQ * 3 + 3, 0);
          startDate = formatDate(lastQuarterStart, true);
          endDate = formatDate(lastQuarterEnd, false);
          break;

        case "Yearly":
          const yearStart = new Date(today.getFullYear(), 0, 1);
          startDate = formatDate(yearStart, true);
          endDate = formatDate(today, false);
          break;

        case "Last Year":
          const lastYearStart = new Date(today.getFullYear() - 1, 0, 1);
          const lastYearEnd = new Date(today.getFullYear() - 1, 11, 31);
          startDate = formatDate(lastYearStart, true);
          endDate = formatDate(lastYearEnd, false);
          break;

        case "Date Range":
          // Leave empty for manual entry
          startDate = "";
          endDate = "";
          break;

        default:
          startDate = "";
          endDate = "";
      }

      this.setState(
        {
          pacing: value,
          startDate,
          endDate,
        },
        () => {
          if (value !== "Date Range" && startDate && endDate) {
            this.fetchUsersByDateRange(startDate, endDate);
          }
        }
      );
    }

    // When user manually inputs start or end date in Date Range
    else if (name === "startDate" || name === "endDate") {
      this.setState({ [name]: value }, () => {
        let { startDate, endDate, pacing } = this.state;
        if (
          pacing === "Date Range" &&
          startDate &&
          endDate
        ) {
           startDate = `${startDate} 00:00:00`;
           endDate = `${endDate} 23:59:59`;
           this.fetchUsersByDateRange(startDate, endDate);
        }
      });
    
  // else if (name === "startDate" || name === "endDate") {
  //     this.setState({ [name]: value }, () => {
  //       if (
  //         this.state.pacing === "Date Range" &&
  //         this.state.startDate &&
  //          this.state.endDate
  //       ) {
  //           this.state.startDate = `${this.state.startDate} 00:00:00`;
  //          this.state.endDate = `${this.state.endDate} 23:59:59`;
  //         alert("fullStart ==>" + this.state.endDate)
  //         alert("fullEnd ==>" + this.state.startDate)
  //         // this.setState({startDate: startDate,endDate: fullEnd})
  //          let { startDate, endDate, pacing } = this.state;
  //         this.fetchUsersByDateRange(startDate,endDate);
  //       }
  //     });

      
    } else {
      this.setState({ [name]: value });
    }
  };


  backButtonHandleChange(e) {
    e.preventDefault();
    this.props.history.push("/CATRole")
  }//end of backButtonHandleChange

  onAdvertiserNameHandleChange(e) {
    var advertiserID = e.target.value;
    let campaignStatusArray = this.state.campaignStatusArray;
    let campaignLeadStatusArray = this.state.campaignLeadStatusArray;
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;
    let getCampaignDetailByADV = this.state.getCampaignDetailByADV;

    if ((getCampaignDetailByADV && getCampaignDetailByADV !== "Select Client") && (campaignLeadStatusArray && campaignLeadStatusArray.length > 0)
      && (startDate !== "") && (endDate !== "")) {
      this.setState({ totalCount: 0 })
    }

    let campID = ""; //sunita-task-3582 -  added code for displaying the particular adv data in table.
    this.setState({ advertiserID, campID: "", advLeadDetails: [] }) //sunita-task-3582-added code for showing blank data if data is not present in table.

    //sunita-task-3575-added below condition for - if same campaign having by number of advertiser So data should load in table.
    if (campaignStatusArray.length === 0 || campaignStatusArray == []) {//not resolved giving issue
      this.setState({ campID: "Select Campaign", generateBtnFlag: false, advLeadDetails: [] })
    }
    else if ((advertiserID && advertiserID !== "Select Advertiser") && (campaignLeadStatusArray && campaignLeadStatusArray.length > 0) && (campID && campID !== "Select Campaign") && (campaignStatusArray && campaignStatusArray.length > 0)) {
      this.onCampaignLeadDetailsHandleChange(advertiserID, campaignLeadStatusArray, campID);

    }
    else {
      this.setState({ generateBtnFlag: false, advLeadDetails: [] })
    }

    if ((advertiserID && advertiserID !== "Select Advertiser")) {
      let data = {
        advertiserID: advertiserID,
      }
      //4470
      fetch("/advertiserReportEngine/getCampaignDetailsByClient", {

        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(res => res.json())
        .then(getCampaignDetailByADV => {
          this.setState({ getCampaignDetailByADV: getCampaignDetailByADV, campaignLoader: "" })
          //alert("getCampaignDetailByADV =>"+JSON.stringify(getCampaignDetailByADV))

        }).catch(function (err) { console.log(err) });
    }

  }//end of onAdvertiserNameHandleChange



  onCampaignLeadDetailsHandleChange(advertiserID, campaignLeadStatusArray, campID, timeLine) {

    // let advcountDetails = [{ "advertiserID": advertiserID, "advertiserName": "", "deliveryLabel": "", "totalAllocation": 0, "totalAccepted": 0, "deliveredLead": 0, "rejectedLead": 0, "qaReviewLead": 0, "balanceLead": 0 }]
    this.setState({ loader: 'lead_loader', generateBtnFlag: false, advLeadDetails: [] });
    // alert("advcountdetails=>" + JSON.stringify(advcountDetails));

    const { user } = this.props.auth;
    const agencyID = user.id;
    let campaignStatusArray = this.state.campaignStatusArray;
    // let campID= this.state.campID;
    // alert("campID=>" + campID);
    this.setState({ agencyID })

    if (this.state.reportKey === "report") {

      if ((advertiserID && advertiserID !== "Select Advertiser") && (campaignLeadStatusArray && campaignLeadStatusArray.length > 0) && (campID && campID !== "Select Campaign") && (timeLine && timeLine !== "Select Timeline")) {

        let data = {
          campID: campID,
          //agencyID: agencyID,                                //3721-Rutuja Kale-VAPT-Agency side--Reports menu--URL Links & API-FE
          leadStatus: campaignLeadStatusArray,
          timeLine: timeLine,
          advertiserID: advertiserID,
          campaignStatus: campaignStatusArray,

        }

        fetch("/advertiserReportEngine/advLeadDetails", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'

          },
          body: JSON.stringify(data)
        }).then(res => res.json())
          .then(advLeadDetails => {
            //  let advcountDetails = advLeadDetails.countDetails;
            let deliveryDetails = advLeadDetails.deliveryDetails;
            let checkedColumnKeys = [], multiTouch = "No";
            if (deliveryDetails.length > 0) { multiTouch = deliveryDetails[0].multiTouch };

            for (const [key, value] of Object.entries(deliveryDetails[0])) {
              if (value === "Yes" || value === "yes") {
                checkedColumnKeys.push(key)

              }
            }

            let customQuestionCount = advLeadDetails.customQuestionCount;
            if (customQuestionCount > 0) {
              checkedColumnKeys.push("Custom Question");
            }

            this.setDataTableColumn(checkedColumnKeys, multiTouch, customQuestionCount)//sunita-task-3413-function called for table columns

            this.setState({ advLeadDetails: advLeadDetails.result, deliveryDetails: advLeadDetails.deliveryDetails, loader: "", checkedColumnKeys, multiTouch, customQuestionCount })
            if (this.state.advLeadDetails.length > 0) {
              this.setState({ generateBtnFlag: true })


            }
            else {

              this.setState({ generateBtnFlag: false })

            }

          }).catch(function (err) { console.log(err) });

      }
    }
    else
      if ((advertiserID && advertiserID !== "Select Advertiser") && (campaignLeadStatusArray && campaignLeadStatusArray.length > 0) && (campaignStatusArray && campaignStatusArray.length > 0) && (campID && campID !== "Select Campaign") && (timeLine && timeLine !== "Select Timeline")) {


        let data = {
          campID: campID,                                   //3721-Rutuja Kale-VAPT-Agency side--Reports menu--URL Links & API-FE
          leadStatus: campaignLeadStatusArray,
          timeLine: timeLine,
          advertiserID: advertiserID,
          campaignStatus: campaignStatusArray,
        }

        fetch("/advertiserReportEngine/advLeadDetails", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'

          },
          body: JSON.stringify(data)
        }).then(res => res.json())
          .then(advLeadDetails => {

            this.setState({ loader: "" }); //sunita-task-3573-added code for displaying loader blank when data not available.
            ///let advcountDetails = advLeadDetails.countDetails;
            let deliveryDetails = advLeadDetails.deliveryDetails;


            let checkedColumnKeys = [], multiTouch = "No";
            if (deliveryDetails.length > 0) { multiTouch = deliveryDetails[0].multiTouch };

            for (const [key, value] of Object.entries(deliveryDetails[0])) {
              if (value === "Yes" || value === "yes") {
                checkedColumnKeys.push(key)
              }
            }

            let customQuestionCount = advLeadDetails.customQuestionCount;

            if (customQuestionCount > 0) {
              checkedColumnKeys.push("Custom Question");
            }
            this.setDataTableColumn(checkedColumnKeys, multiTouch, customQuestionCount)//sunita-task-3413-function called for table columns



            this.setState({ advLeadDetails: advLeadDetails.result, deliveryDetails: advLeadDetails.deliveryDetails, checkedColumnKeys, multiTouch, customQuestionCount })


            if (this.state.advLeadDetails.length > 0) {
              this.setState({ generateBtnFlag: true })
            }
            else {
              this.setState({ generateBtnFlag: false })

            }



          }).catch(function (err) { console.log(err) });

      }

  }

  //Nilesh-5722- Modified searchHandleChange function
  searchHandleChange = (e) => {
    e.preventDefault();
    
    const {
      getCampaignDetailByADV: campID,
      advertiserID,
      advertiserList,
      pacing,
      startDate,
      endDate,
      campaignLeadStatusArray,
      orgIDArray,
      userIDArray
    } = this.state;

    const leadStatus = campaignLeadStatusArray ? campaignLeadStatusArray.toString() : "";

    // ----------------------- 📝 Derive advertiserName -----------------------
    let advertiserName = "";
    if (advertiserID && advertiserID !== "Select Advertiser") {
      const found = advertiserList.find(ad => ad.advertiserID === advertiserID);
      advertiserName = found ? found.advertiserName : "";
    }

    // ----------------------- ❗ NEW combined‑missing check -------------------
    const isClientSelected = advertiserID && advertiserID !== "Select Advertiser";
    const isUserSelected = Array.isArray(userIDArray) && userIDArray.length > 0;

    if ((!pacing || pacing === "Default") && !isClientSelected && !isUserSelected) {
      Swal.fire({
        type: "warning",
        title: "Please select Pacing and either Lead Uploaded By User or Client",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
        preConfirm: () => window.location.reload()
      });
      return;
    }

    // ----------------------- ⚠️ Individual validations ----------------------
    // 1️⃣ Pacing required
    if (!pacing || pacing === "Default") {
      Swal.fire({
        type: "warning",
        title: "Please select Pacing",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
        preConfirm: () => window.location.reload()
      });
      return;
    }

    // 2️⃣ Must choose client or user
    if (!isClientSelected && !isUserSelected) {
      Swal.fire({
        type: "warning",
        title: "Please select either Lead Uploaded By User or Client",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
        preConfirm: () => window.location.reload()
      });
      return;
    }

    // 3️⃣ Date range requires both dates
    if (pacing === "Date Range" && (!startDate || !endDate)) {
      Swal.fire({
        type: "warning",
        title: "Please select Start Date and End Date",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
        preConfirm: () => window.location.reload()

      });
      return;
    }
    //Add timestamp if pacing is Date Range
    let fullStartDate = startDate;
    let fullEndDate = endDate;

    if (pacing === "Date Range" && startDate && endDate) {
    fullStartDate = `${startDate} 00:00:00`;
    fullEndDate = `${endDate} 23:59:59`;
    }


    // ----------------------- 🚀 API call -----------------------
    this.setState({ loader_progress: "loader_campaign_list" });

    const data = {
      advertiserID,
      advertiserName,
      startDate: fullStartDate,
      endDate: fullEndDate,
      leadStatus,
      campID,
      orgIDs: orgIDArray,
      userIDs: userIDArray,
      pacing
    };
    // alert("data ==>" + JSON.stringify(data))
    fetch("/dashboardCAT/clientLeadReportDetailsCAT", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then(({ result = [] }) => {
        this.setState({ loader_progress: "" });

        if (result.length) {
          const chunkSize = 30000;
          const chunks = [];
          for (let i = 0; i < result.length; i += chunkSize)
            chunks.push(result.slice(i, i + chunkSize));

          this.setState({
            clientLeadDetails: result,
            splitedArray: chunks,
            totalCount: result.length
          });
        } else {
          Swal.fire({
            type: "warning",
            title: "No records Found",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
            preConfirm: () => window.location.reload()
          });
        }
      })
      .catch(err => {
        console.error(err);
        this.setState({ loader_progress: "" });
      });
  };

  handledownloadLead(e) {
    this.setState({ loader_progress: "loader_campaign_list" });
    let clientLeadDetails = this.state.clientLeadDetails;
    let advertiserID = this.state.advertiserID;
    let advertiserList = this.state.advertiserList;
    let advertiserName = this.state.advertiserName;

    for (let i = 0; i < advertiserList.length; i++) {
      if (advertiserList[i].advertiserID.toString() === advertiserID) { 
        advertiserName = advertiserList[i].advertiserName;
      }
    }

    if (clientLeadDetails.length > 0) {
      var ws = xlsx.utils.json_to_sheet(clientLeadDetails);
      var wb = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, "Lead");
      var buf = xlsx.write(wb, { bookType: "xlsx", type: "buffer" });

      function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i)
          view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
      this.setState({ loader_progress: "" }); 
      var fileName = "CAT Lead Assessment Report.xlsx";
      saveAs(
        new Blob([s2ab(buf)], { type: "application/octet-stream" }),
        fileName
      );
      // ✅ Success Swal for download
      Swal.fire({
        type: "success",
        title: "File downloaded successfully",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        preConfirm: () => window.location.reload()

      });
    }

  }

  componentWillMount() {
    if (!this.props.auth.isAuthenticated) {
      this.props.history.push('/userLogin');
    }
    else {
      let reportKey, reportID, advertiserID, reportName, type;

      if (this.props.location.state !== undefined) {
        advertiserID = this.props.location.state.advID;
        reportKey = this.props.location.state.reportKey;
        reportID = this.props.location.state.reportID;
        // this.state.reportID = reportID;
        reportName = this.props.location.state.reportName;
        // this.state.reportName = reportName;
        this.setState({ reportID: reportID, reportName: reportName })//kiran-2834-removing console warning-use setState
        type = this.props.location.state.type;
      }

      // const { isAuthenticated } = this.props.auth;//kiran-2834-removing console warning-no used
      const { user } = this.props.auth;
      const agencyID = user.id;
      this.setState({
        agencyID: agencyID,
        advertiserID: advertiserID,
        reportKey: reportKey,
        generateBtnFlag: false,
        reportName: reportName,
        type: type,
      })

      if (this.state.reportKey === "report") {
        this.setState({ drpdisabled_report: "drpdisable_report" })
      }
      else {
        this.setState({ drpdisabled_report: "" })
      }


      let data = {
        //agencyID: this.state.agencyID,                //3721-Rutuja Kale-VAPT-Agency side--Reports menu--URL Links & API-FE
        advertiserID: advertiserID,
        reportID: reportID,
      }
      fetch("/dashboardCAT/clientListCAT", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //authorization: token,
        },
        body: JSON.stringify(data)
      }).then(res => res.json())
        .then(advertiserList => {
          this.setState({ advertiserList, advertiserList1: advertiserList })
        }
        ).catch(function (err) { console.log(err) });
    }

  }//end of componentWillMount

  //Aman-4660 -MBAdmin-(to get UserName and set)eport - Lead File Tracking Report- DMA's Upload lead file count and file details
  //   NameHandleChange(e) {
  //     e.preventDefault();

  //     if(e.target.value!=="Select Publisher"){
  //       this.setState({ selectedUser : this.state.UserName[e.target.value]});
  //       alert("selectedUser ==>" + JSON.stringify(this.state.selectedUser))

  //       let selectedUser = this.state.UserName[e.target.value];
  //       let data = {
  //         client:"yes",
  //         pID: selectedUser.orgID 
  //     }
  //     alert("data -->" + JSON.stringify(data))
  //     this.setState({ LeadFileTrackingDetails: "" })
  //     }
  //     else{

  //       this.setState({ selectedUser : "" , selectedClient :""});
  //       document.getElementById("client").value ="Select Client";
  //       this.setState({ LeadFileTrackingDetails: "" })
  //       let data = {
  //         client:"no",
  //     }
  //     }
  //     }

  // NameHandleChange = (e) => {
  //     const selectedUserID = parseInt(e.target.value);;
  //   alert("===>" + JSON.stringify(selectedUserID))
  //   alert(" this.state.UserName===>" + JSON.stringify( this.state.UserName))
  //     if (selectedUserID !== "Select Publisher") {
  //         // const selectedUser = this.state.UserName.find(user => user.orgID === selectedUserID);
  //         // alert("Selected User Data=== " + JSON.stringify(selectedUser));

  //         this.setState({
  //             selectedUserID: selectedUserID,  // ✅ This is what will be sent to backend
  //           //  selectedUser: selectedUser,
  //             LeadFileTrackingDetails: ""
  //         });

  //         alert("Selected User Data: " + JSON.stringify(selectedUserID));
  //     } else {
  //         this.setState({
  //             selectedUserID: "",  // ✅ Reset if "Select Publisher"
  //             //selectedUser: "",
  //             selectedClient: "",
  //             LeadFileTrackingDetails: ""
  //         });
  //         document.getElementById("client").value = "Select Client";
  //     }
  // };
  // NameHandleChange = (e) => {
  //     const value = e.target.value;

  //     if (value !== "Select Publisher") {
  //         const [orgIDStr, userIDStr] = value.split("|");
  //         const orgID = parseInt(orgIDStr);
  //         const userID = parseInt(userIDStr);

  //         // Find the user based on userID (since orgID may be duplicate)
  //         const selectedUser = this.state.UserName.find(user => user.userID === userID);

  //         this.setState({
  //             selectedUserKey: value,
  //             selectedUserID: orgID,      // orgID sent to backend
  //             selectedUserUserID: userID, // userID sent to backend
  //             selectedUser: selectedUser,
  //             LeadFileTrackingDetails: ""
  //         });

  //         // alert("Selected User: " + JSON.stringify(selectedUser));
  //     } else {
  //         this.setState({
  //             selectedUserKey: "Select Publisher",
  //             selectedUserID: "",
  //             selectedUserUserID: "",
  //             selectedUser: "",
  //             selectedClient: "",
  //             LeadFileTrackingDetails: ""
  //         });
  //         document.getElementById("client").value = "Select Client";
  //     }
  // };

  // handleMultiUserSelect = (e, user) => {
  //   const value = e.target.value;
  //   const { selectedUserKeys, selectedUsers } = this.state;

  //   if (e.target.checked) {
  //     this.setState({
  //       selectedUserKeys: [...selectedUserKeys, value],
  //       selectedUsers: [...selectedUsers, user]
  //     });
  //   } else {
  //     this.setState({
  //       selectedUserKeys: selectedUserKeys.filter(k => k !== value),
  //       selectedUsers: selectedUsers.filter(u => `${u.orgID}|${u.userID}` !== value)
  //     });
  //   }
  // };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  dropdownRef = React.createRef();
  clientDropdownRef = React.createRef();

  //Nilesh-5722- This function used for users clicking outside close the list
  handleClickOutside = (event) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ showDropdown: false });
    }
    if (this.clientDropdownRef.current && !this.clientDropdownRef.current.contains(event.target)) {
      this.setState({ showClientDropdown: false });
    }
  };

  //Nilesh-5722- This function used for multi users selection
  handleMultiUserSelect = (e, user) => {
    const value = `${user.orgID}|${user.userID}`;
    let selectedUserKeys = [...this.state.selectedUserKeys];
    let selectedUsers = [...this.state.selectedUsers];

    if (e.target.checked) {
      selectedUserKeys.push(value);
      selectedUsers.push(user);
    } else {
      selectedUserKeys = selectedUserKeys.filter(v => v !== value);
      selectedUsers = selectedUsers.filter(u => `${u.orgID}|${u.userID}` !== value);
    }

    const orgIDArray = selectedUserKeys.map(v => parseInt(v.split("|")[0]));
    const userIDArray = selectedUserKeys.map(v => parseInt(v.split("|")[1]));

    this.setState({
      selectedUserKeys,
      selectedUsers,
      orgIDArray,
      userIDArray
    });
  };

  //Nilesh-5722- This function used for fetching PC/PNC users 
  fetchUsersByDateRange = (fullStart, fullEnd) => {
    this.setState({ loader_progress: "loader_campaign_list" });
    const data = {
      startDate: fullStart,
      endDate: fullEnd,
      pacing: this.state.pacing // include pacing value too
    };
    // alert("data ==>" + JSON.stringify(data))
    fetch("/dashboardCAT/allPcPncUserCAT", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then((UserNameDetails) => {
        this.setState({ loader_progress: "" }); //Chaitanya-5595-Added loader
        // alert("UserNameDetails -->" + JSON.stringify(UserNameDetails))
        this.setState({ allUserNames: UserNameDetails });
        let userNameArray = [];
        if (UserNameDetails.length > 0) {
          for (let i = 0; i < UserNameDetails.length; i++) {
            userNameArray.push({ firstName: UserNameDetails[i].firstName, lastName: UserNameDetails[i].lastName, orgID: UserNameDetails[i].orgID, userID: UserNameDetails[i].userID });
          }
          userNameArray = Array.from(
            new Set(
              userNameArray.map((el) =>
                JSON.stringify(el)
              )
            )
          ).map((el) => JSON.parse(el));
        }
        this.setState({ UserName: userNameArray })
        //   alert("UserName ==>" + JSON.stringify(this.state.UserName))
      }).catch(function (err) { console.log(err); });
  };
  render() {
    const asterisk =
    {
      color: 'red',
    }

    return (
      <div>
        <Navigation />
        <div style={{ paddingBottom: '60px', paddingTop: '100px' }} class="container-fluid ">

          <div class="row">

            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              {/* kiran-2834-removing console warning-added "#/" */}
              <a style={{ color: '#056eb8' }} href="#/" onClick={this.backButtonHandleChange} ><FaArrowAltCircleLeft size={32} title="Back to CAT Dashboard" /></a>
            </div>

            <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8" align="center">
              <label id="labelDI">Lead Assessment Report</label>
            </div>

          </div>
          {/* Nilesh-5722-Modified UI code */}
          <div
            className="shadow-container"
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              marginTop: "3%",
              marginLeft: "2%",
              marginRight: "2%"
            }}
          >
            <div className="d-flex" style={{ width: '100%', gap: '30px', flexWrap: 'nowrap', alignItems: 'flex-end' }}>

              {/* Pacing */}
              <div style={{ width: '16%' }}>
                <label style={{ fontSize: '14px', color: '#14254A', fontFamily: 'sans-serif' }}>
                  <b>Pacing</b> <span style={{ color: "red" }}>*</span>
                  <HtmlTooltip
                    placement="right"
                    title={
                      <ul style={{ margin: 0, paddingLeft: '15px' }}>
                        <li>
                          Pacing defines the time range for filtering uploaded leads.
                        </li>
                        <li>
                          Based on the selected pacing, relevant users and data will be shown.
                        </li>
                        <li>
                          Select "Date Range" to manually enter start and end dates.
                        </li>
                      </ul>
                    }
                  >
                    <Icon type="question-circle" />
                  </HtmlTooltip>

                </label>
                <select
                  name="pacing"
                  value={this.state.pacing}
                  onChange={this.handleChange}
                  style={{
                    width: '100%',
                    height: '34px',
                    border: '1px solid #cccccc',
                    backgroundColor: "#FFFFFF",
                    borderRadius: '3px',
                    fontFamily: 'sans-serif',
                    color: '#555555'
                  }}
                >
                  <option value="Default">Select Pacing</option>
                  <option value="Today">Today</option>
                  <option value="Yesterday">Yesterday</option>
                  <option value="Weekly">This Week</option>
                  <option value="Monthly">This Month</option>
                  <option value="Quarterly">This Quarter</option>
                  <option value="Yearly">This Year</option>
                  <option value="Last Week">Last Week</option>
                  <option value="Last Month">Last Month</option>
                  <option value="Last Quarter">Last Quarter</option>
                  <option value="Last Year">Last Year</option>
                  <option value="Date Range">Date Range</option>
                </select>
              </div>

              {/* Date Range Fields */}
              {this.state.pacing === "Date Range" && (
                <>
                  <div style={{ width: '12%' }}>
                    <label style={{ fontSize: '14px', color: '#14254A' }}>
                      <b>Start Date</b> <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="date"
                      name="startDate"
                      value={this.state.startDate}
                      onChange={this.handleChange}
                      className="form-control"
                      style={{ height: '34px' }}
                      required
                    />
                  </div>

                  <div style={{ width: '12%' }}>
                    <label style={{ fontSize: '14px', color: '#14254A' }}>
                      <b>End Date</b> <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="date"
                      name="endDate"
                      value={this.state.endDate}
                      onChange={this.handleChange}
                      className="form-control"
                      style={{ height: '34px' }}
                      required
                    />
                  </div>
                </>
              )}

              {/* Lead Uploaded By */}
              <div style={{ width: '33%' }}>
                <label style={{ fontSize: '14px', color: '#14254A', fontFamily: 'sans-serif' }}>
                  <b>Lead Uploaded By</b>
                  <HtmlTooltip
                    placement="right"
                    title={<li>{"DMA Name"}</li>}
                  >
                    <Icon type="question-circle" />
                  </HtmlTooltip>
                </label>
                <div style={{ position: "relative", width: "100%" }} ref={this.dropdownRef}>
                  <div
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "6px",
                      background: "#fff",
                      cursor: "pointer"
                    }}
                    onClick={() => this.setState({ showDropdown: !this.state.showDropdown })}
                  >
                    {this.state.selectedUsers.length > 0
                      ? this.state.selectedUsers.map(u => `${u.firstName} ${u.lastName}`).join(", ")
                      : "Select Users"}
                  </div>

                  {this.state.showDropdown && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        width: "100%",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        background: "#fff",
                        maxHeight: "350px",
                        overflowY: "auto",
                        zIndex: 10
                      }}
                    >
                      <div style={{ padding: "6px" }}>
                        <input
                          type="text"
                          placeholder="Search user..."
                          value={this.state.searchText}
                          onChange={(e) => this.setState({ searchText: e.target.value })}
                          style={{ width: "100%", padding: "4px", boxSizing: "border-box" }}
                        />
                      </div>

                      {this.state.UserName
                        .filter(user => {
                          const fullName = `${user.firstName} ${user.lastName}`.toLowerCase();
                          return fullName.includes(this.state.searchText.toLowerCase());
                        })
                        .map((user, i) => {
                          const value = `${user.orgID}|${user.userID}`;
                          const isChecked = this.state.selectedUserKeys.includes(value);
                          return (
                            <div key={i}>
                              <label style={{ marginLeft: '5px' }}>
                                <input
                                  type="checkbox"
                                  value={value}
                                  checked={isChecked}
                                  onChange={(e) => this.handleMultiUserSelect(e, user)}
                                />
                                &nbsp;{user.firstName} {user.lastName}
                              </label>
                            </div>
                          );
                        })}
                    </div>
                  )}
                </div>
              </div>

              {/* OR Label */}
              <div
                style={{
                  width: "5%",
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "#0b3286ff",
                  fontFamily: "sans-serif",
                  fontSize: "16px"
                }}
              >
                OR
              </div>

              {/* Client */}
              <div style={{ width: '33%' }}>
                <label style={{ fontSize: '14px', color: '#14254A', fontFamily: 'sans-serif' }}>
                  <b>Client</b>
                </label>
                <div style={{ position: "relative", width: "100%" }} ref={this.clientDropdownRef}>
                  <div
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "6px",
                      background: "#fff",
                      cursor: "pointer"
                    }}
                    onClick={() => this.setState({ showClientDropdown: !this.state.showClientDropdown })}
                  >
                    {this.state.selectedAdvertiserName || "Select Client"}
                  </div>

                  {this.state.showClientDropdown && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        width: "100%",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        background: "#fff",
                        maxHeight: "350px",
                        overflowY: "auto",
                        zIndex: 10
                      }}
                    >
                      <div style={{ padding: "6px" }}>
                        <input
                          type="text"
                          placeholder="Search client..."
                          value={this.state.clientSearchText}
                          onChange={(e) => this.setState({ clientSearchText: e.target.value })}
                          style={{ width: "100%", padding: "4px", boxSizing: "border-box" }}
                        />
                      </div>

                      {this.state.advertiserList
                        .filter(ad =>
                          `${ad.advertiserID} - ${ad.advertiserName}`.toLowerCase()
                            .includes(this.state.clientSearchText.toLowerCase())
                        )
                        .map((ad, i) => (
                          <div
                            key={i}
                            style={{ padding: "6px", cursor: "pointer" }}
                            onClick={() => {
                              this.setState({
                                advertiserID: ad.advertiserID,
                                selectedAdvertiserName: `${ad.advertiserID} - ${ad.advertiserName}`,
                                showClientDropdown: false
                              });
                              this.onAdvertiserNameHandleChange({ target: { value: ad.advertiserID } });
                            }}
                          >
                            {ad.advertiserID} - {ad.advertiserName}
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Search Button */}
              <div style={{ width: '10%', alignSelf: 'flex-end' }}>
                <button
                  className="btn w-100"
                  style={{
                    backgroundImage: "linear-gradient(to left, #007CC3,#193D8F)",
                    color: "white",
                    height: "38px"
                  }}
                  type="button"
                  onClick={this.searchHandleChange}
                >
                  Search
                </button>
              </div>
            </div>

            {/* Loader */}
            <div align="center" id={this.state.loader_progress}></div>

            {/* Total Count & Download */}
            {this.state.totalCount > 0 && (
              <div style={{
                backgroundColor: 'white',
                margin: '20px 0',
                border: '1px solid #cccccc',
                borderRadius: '3px'
              }}>
                <div style={{ padding: '20px 25px 10px 25px' }}>
                  <div className="row">
                    <div className="col-md-8">
                      <label style={{ color: "#14254A", paddingTop: "1%", paddingLeft: "2%" }}>
                        <span>Total Leads Count&nbsp;:&nbsp;</span>
                        <span>{this.state.totalCount}</span>
                      </label>
                    </div>

                    <div className="col-md-4">
                      <button
                        title="Leads reviewed by the QA team will be displayed"
                        type="button"
                        className="btn add-button"
                        style={{ float: "right", marginRight: "10%" }}
                        value={this.state.clientLeadDetails}
                        onClick={this.handledownloadLead}
                        disabled={this.state.totalCount >= 30000}
                      >
                        Download
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

        </div>
        <Footer />
      </div>
    )
  }
}

CATLeadReport.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  auth: state.auth
})

export default connect(mapStateToProps, { logoutUser })(withRouter(CATLeadReport));
